var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm-5 8.414L5.414 20H20v-4.586zM20 4H4v14.586L14.293 8.293a1 1 0 0 1 1.414 0L20 12.586zM8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }